module.exports = __webpack_public_path__ + "static/media/file-document-box-outline.8d8ec109.svg";